import React from "react";

/**
 * Full Tailwind class strings per tone. Kept complete so Tailwind retains them.
 * @type {Record<string, { pill: string, dot: string }>}
 */
const TONE_CLASSES = {
  brand: { pill: "bg-light-orange text-orange-primary", dot: "bg-orange-primary" },
  ai: { pill: "bg-ai-bg text-ai-text", dot: "bg-ai" },
  internal: { pill: "bg-internal-bg text-internal-text", dot: "bg-internal" },
  danger: { pill: "bg-danger-bg text-danger-dark", dot: "bg-danger" },
  success: { pill: "bg-success-bg text-success", dot: "bg-success" },
  info: { pill: "bg-info-bg text-info", dot: "bg-info" },
  neutral: { pill: "bg-gray-100 text-gray-700", dot: "bg-gray-400" },
  // Tailwind's own violet, not the `ai` tokens: purple is otherwise kept for the AI bot.
  violet: { pill: "bg-violet-50 text-violet-700", dot: "bg-violet-500" },
};

/**
 * Small pill badge conveying a status via semantic color.
 *
 * @param {Object} props
 * @param {'brand'|'ai'|'internal'|'danger'|'success'|'info'|'neutral'|'violet'} props.tone - Semantic color.
 * @param {React.ReactNode} props.children - Badge label content.
 * @param {boolean} [props.dot=false] - Show a leading colored dot.
 */
export const StatusBadge = ({ tone = "neutral", children, dot = false }) => {
  const toneClass = TONE_CLASSES[tone] || TONE_CLASSES.neutral;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold ${toneClass.pill}`}
    >
      {dot && (
        <span
          aria-hidden="true"
          className={`inline-block w-1.5 h-1.5 rounded-full ${toneClass.dot}`}
        />
      )}
      {children}
    </span>
  );
};
